<template>
  <path
    d="M12 6.34018L18.95 3.76018C19.75 3.46018 20.53 4.24018 20.24 5.05018L17.66 12.0002L12 6.34018ZM21.9 19.0702L4.93 2.10018C4.54 1.71018 3.91 1.71018 3.52 2.10018C3.13 2.49018 3.13 3.12018 3.52 3.51018L7.88 7.87018L3.68 9.43018C3.27 9.59018 3 9.97018 3 10.4002C3 10.8202 3.26 11.2002 3.65 11.3602L10.07 13.9302L12.64 20.3502C12.8 20.7402 13.18 21.0002 13.6 21.0002C14.03 21.0002 14.42 20.7302 14.57 20.3302L16.13 16.1302L20.49 20.4902C20.88 20.8802 21.51 20.8802 21.9 20.4902C22.29 20.0902 22.29 19.4602 21.9 19.0702Z"
  />
</template>
